import React, { useState, useRef, useEffect } from "react";
import "../css/google-auth-popup.css";  
import { forgotGoogleAuth } from "../services/user-service";  
import { QRCodeSVG } from "qrcode.react";  
import { toast } from "react-toastify";  

const GoogleAuthPopup = ({ onOtpSubmit, onClose, otpError }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");

   const [username, setUsername] = useState("");
  const [qrCode, setQrCode] = useState(null);
  const [forgotError, setForgotError] = useState("");
  const [showForgotSection, setShowForgotSection] = useState(false);
  const [showQrPopup, setShowQrPopup] = useState(false);  

   const inputRefs = useRef([]);

   const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;  

    let newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

     if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

   const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

   const handleVerifyOtp = () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      toast.error("Please enter a 6-digit OTP.");
      return;
    }
    onOtpSubmit(enteredOtp);
  };

   const handleRetrieveQRCode = () => {
    if (!username.trim()) {
      setForgotError("Username is required.");
      return;
    }

    forgotGoogleAuth({ username })
      .then((response) => {
        setQrCode(response);
        setShowForgotSection(false);  
        setShowQrPopup(true);  
      })
      .catch((err) => {
        setForgotError(err.message || "User not found or error generating QR Code.");
      });
  };

  const handleBackToOtp = () => {
    setShowForgotSection(false);
    setShowQrPopup(false);  
    setQrCode(null);
    setUsername("");
    setForgotError("");
  };

  useEffect(() => {
    if (otpError) {
      setError(otpError);
    }
  }, [otpError]);

  return (
    <div className="auth-popup-overlay">
      <div className="auth-popup-container">
        <div className="auth-popup-card">
           {!showForgotSection && !showQrPopup && (
            <>
              <div className="auth-heading">
                <h2 className="auth-main-heading">Google Authenticator</h2>
                <p className="auth-subheading">
                  Enter the 6-digit code from your Google Authenticator app.
                </p>
              </div>

               <div className="auth-otp-inputs">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    className="auth-input otp-box"
                    value={digit}
                    maxLength="1"
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    ref={(el) => (inputRefs.current[index] = el)}
                  />
                ))}
              </div>

              
              <div className="auth-buttons">
                <button className="auth-verify-btn" onClick={handleVerifyOtp}>
                  Verify OTP
                </button>
                <button className="auth-close-btn" onClick={onClose}>
                  Close
                </button>
              </div>

              <div className="auth-forgot-section">
                <p className="auth-forgot-text" onClick={() => setShowForgotSection(true)}>
                  Forgot Google Authentication?
                </p>
              </div>
            </>
          )}

           {showForgotSection && !showQrPopup && (
            <div className="forgot-google-auth-container">
              <h4 className="forgot-heading">Recover Google Authentication</h4>

               <input
                type="text"
                className="auth-input"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />

              {forgotError && <p className="auth-error">{forgotError}</p>}

               <button className="auth-verify-btn1" onClick={handleRetrieveQRCode}>
                Retrieve QR Code
              </button>
              <button className="auth-close-btn1" onClick={onClose}>
                Back
              </button>
            </div>
          )}
        </div>
      </div>

       {showQrPopup && (
        <div className="auth-popup-overlay">
          <div className="auth-popup-container">
            <div className="auth-popup-card">
              <h3 className="qr-heading">Scan QR Code</h3>
              <p className="qr-scanheading">Scan this QR code with Google Authenticator:</p>
              <QRCodeSVG className="qrcode" value={qrCode} size={250} />
              <button className="auth-close-btn2" onClick={handleBackToOtp}>
                Back to OTP verification page
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoogleAuthPopup;
